export class IExtraActionFooterButton {
    label: string;
    action: (...params) => any;
    styleClassName?: string;
    disabled?: boolean;
    icon?: string;
}
